const initState = {
  sportContestData: [],
  sportContestLastDocument: null,
  sportContestHasMoreDocument: false,
  contestOrganizer: null,
  contestDetails: {
    data: [],
    lastVisible: null,
    hasMore: true,
  },

  brandAmbassodarContestData: [],
  brandAmbassodarContestLastDocument: null,
  brandAmbassodarContestHasMoreDocument: false,

  contestVoteGetter: [],
  contestVoteGetterLastDocument: null,
  contestVoteGetterHasMoreDocument: true,

  sportContestAthletes: [],
  sportContestAthletesLastDocument: null,
  sportContestAthletesHasMoreDocument: false,

  horrorBadges: [],
  horrorBadgesLastDocument: null,
  horrorBadgesHasMoreDocument: false,

  brandAmbassadorContestParticipants: [],
  brandAmbassadorContestParticipantsLastDocument: null,
  brandAmbassadorContestParticipantsHasMoreDocument: false,

  brandAmbassadorContestBadges: [],
  brandAmbassadorContestBadgesLastDocument: null,
  brandAmbassadorContestBadgesHasMoreDocument: false,

  contestByAthlete: [],
  contestByAthleteLastDocument: null,
  contestByAthleteHasMoreDocument: false,

  brandAmbassadorContestVideos: [],
};

const contestReducer = (state = initState, action) => {
  switch (action.type) {
    case "GET_AMBASSADOR_VIDEOS":
      return {
        ...state,
        brandAmbassadorContestVideos: action.payload,
      };
    case "GET_AMBASSADOR_BADGES":
      return {
        ...state,
        brandAmbassadorContestBadges: action.payload.data,
        brandAmbassadorContestBadgesHasMoreDocument:
          action.payload.hasMoreDocument,
        brandAmbassadorContestBadgesLastDocument: action.payload.lastDocument,
      };
    case "GET_AMBASSADOR_BADGES_LOADMORE":
      return {
        ...state,
        brandAmbassadorContestBadges: [
          ...state.brandAmbassadorContestBadges,
          ...action.payload.data,
        ],
        brandAmbassadorContestBadgesHasMoreDocument:
          action.payload.hasMoreDocument,
        brandAmbassadorContestBadgesLastDocument: action.payload.lastDocument,
      };
    case "GET_CONTEST_VOTE_GETTER_BADGES":
      return {
        ...state,
        contestVoteGetter: action.payload.data,
        contestVoteGetterHasMoreDocument: action.payload.hasMoreDocument,
        contestVoteGetterLastDocument: action.payload.lastDocument,
      };
    case "GET_ATHLETE_BY_ATHLETE":
      return {
        ...state,
        contestByAthlete: action.payload.data,
        contestByAthleteHasMoreDocument: action.payload.hasMoreDocument,
        contestByAthleteLastDocument: action.payload.lastDocument,
      };
    case "GET_SPORT_CONTEST":
      return {
        ...state,
        sportContestAthletes: action.payload.data,
        sportContestAthletesHasMoreDocument: action.payload.hasMoreDocument,
        sportContestAthletesLastDocument: action.payload.lastDocument,
      };
    case "GET_SPORT_CONTEST_LOADMORE":
      return {
        ...state,
        sportContestAthletes: [
          ...state.sportContestAthletes,
          ...action.payload.data,
        ],
        sportContestAthletesHasMoreDocument: action.payload.hasMoreDocument,
        sportContestAthletesLastDocument: action.payload.lastDocument,
      };
    case "GET_HORROR_BADGES":
      return {
        ...state,
        horrorBadges: action.payload.data,
        horrorBadgesLastDocument: action.payload.lastDocument,
        horrorBadgesHasMoreDocument: action.payload.hasMoreDocument,
      };
    case "GET_HORROR_BADGES_LOADMORE":
      return {
        ...state,
        horrorBadges: [...state.horrorBadges, ...action.payload.data],
        horrorBadgesLastDocument: action.payload.lastDocument,
        horrorBadgesHasMoreDocument: action.payload.hasMoreDocument,
      };
    case "GET_AMBASSADOR_PARTICIPANTS":
      return {
        ...state,
        brandAmbassadorContestParticipants: action.payload.data,
        brandAmbassadorContestParticipantsLastDocument:
          action.payload.lastDocument,
        brandAmbassadorContestParticipantsHasMoreDocument:
          action.payload.hasMoreDocument,
      };
    case "GET_CONTEST_DATA":
      return {
        ...state,
        sportContestData: action.payload.data,
        sportContestLastDocument: action.payload.lastDocument,
        sportContestHasMoreDocument: action.payload.hasMoreDocument,
      };
    case "GET_CONTEST_DATA_LOADMORE":
      return {
        ...state,
        sportContestData: [...state.sportContestData, ...action.payload.data],
        sportContestLastDocument: action.payload.lastDocument,
        sportContestHasMoreDocument: action.payload.hasMoreDocument,
      };
    case "FETCH_SCHOOL_CONTESTS_SUCCESS":
      return {
        ...state,
        sportContestData: action.payload.isLoadingMore
          ? [...state.sportContestData, ...action.payload.data]
          : action.payload.data,
        sportContestLastDocument: action.payload.lastVisible,
        sportContestHasMoreDocument: action.payload.hasMore,
      };
    case "GET_BRAND_AMBASSODAR_CONTEST":
      return {
        ...state,
        brandAmbassodarContestData: action.payload.data,
        brandAmbassodarContestHasMoreDocument: action.payload.hasMoreDocument,
        brandAmbassodarContestLastDocument: action.payload.lastDocument,
      };
    case "GET_BRAND_AMBASSODAR_CONTEST_LOADMORE":
      return {
        ...state,
        brandAmbassodarContestData: [
          ...state.brandAmbassodarContestData,
          ...action.payload.data,
        ],
        brandAmbassodarContestHasMoreDocument: action.payload.hasMoreDocument,
        brandAmbassodarContestLastDocument: action.payload.lastDocument,
      };
    case "FETCH_CONTESTS_ORGANIZER_SUCCESS":
      return {
        ...state,
        contestOrganizer: action.payload,
      };
    case "FETCH_CONTESTS_DETAILS_SUCCESS":
      return {
        ...state,
        contestDetails: {
          data: action.payload.isLoadingMore
            ? [...state.contestDetails.data, ...action.payload.data]
            : action.payload.data,
          lastVisible: action.payload.lastVisible,
          hasMore: action.payload.hasMore,
        },
      };
    default:
      return {
        ...state,
      };
  }
};
export default contestReducer;
